import React, { memo } from 'react'

import {
  ArrowLeft, ArrowRight, Button, Icon,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { bool, func, oneOf } from 'prop-types'

import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'

import { NOOP } from 'Utils/stableDefaults'

const arrowIconSize = { height: '20px', width: '20px' }
// No `color` prop: Triangle's button rule forces the glyph to the button's `currentColor`
// with `!important`, so the arrows are coloured in _image_gallery_modal.scss instead.
const ICONS = {
  previous: <Icon svgComponent={ArrowLeft} size={arrowIconSize} notSpaced />,
  next: <Icon svgComponent={ArrowRight} size={arrowIconSize} notSpaced />,
}

// Steps to the previous or next image in the gallery.
function Arrow({ direction, isDisabled = false, onClick = NOOP }) {
  const t = useTranslation()

  return (
    <Button
      type="secondary"
      size="small"
      variant="only-icon"
      actionType="button"
      icon={ICONS[direction]}
      customClass={`image-gallery-modal__arrow image-gallery-modal__arrow--${direction}`}
      disabled={isDisabled}
      onClick={onClick}
      aria-label={t(`imageGallery.modal.${direction}`)}
    />
  )
}

Arrow.propTypes = {
  direction: oneOf(['previous', 'next']).isRequired,
  isDisabled: bool,
  onClick: func,
}

export default memo(Arrow)
